import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import FiltersEditor from '../filters-editor';
import { FilterEditorContext } from '../../context';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import FilterName from '../filter-name';
import FilterNameAndDescription from '../name-and-description';
import style from './style.module.less';
import { FILTERSET_EDITOR_TYPE_ALLOCATION_RULE, FILTERSET_EDITOR_TYPE_ORDER_FILTER } from '../../constants/filterset-editor-type';

const EditorForm = ({ filtersetEditorType }) => {
  const { isLoadingFilters } = useContext(FilterEditorContext);
  return (
    <>
      {isLoadingFilters && (
        <div className={style['loading-wrapper']}>
          <LoadingIndicator className={style['loading-indicator']} />
        </div>
      )}
      {!isLoadingFilters && filtersetEditorType === FILTERSET_EDITOR_TYPE_ALLOCATION_RULE && <FilterName />}
      {!isLoadingFilters && filtersetEditorType === FILTERSET_EDITOR_TYPE_ORDER_FILTER && <FilterNameAndDescription />}
      {!isLoadingFilters && <FiltersEditor />}
    </>
  );
};

EditorForm.propTypes = {
  filtersetEditorType: PropTypes.oneOf([FILTERSET_EDITOR_TYPE_ALLOCATION_RULE, FILTERSET_EDITOR_TYPE_ORDER_FILTER]),
};

export default EditorForm;
